<template>
	<section class="Input">
		<A class="icon-camera"></A>
		<textarea ref="input" v-model="text" rows="1" placeholder="メッセージを入力する..."></textarea>
		<A class="icon-paper-plane" @click="onSendMessage" :disabled="!text"></A>
	</section>
</template>

<script>
	import whevent from 'whevent';
	import { mapState } from 'vuex';
	import { sendDM } from '../services/history';

	export default {
		data() {
			return {
				text: ''
			};
		},

		methods: {
			onSendMessage() {
				if (!this.text) return;
				if (!this.readonly) {
					whevent.emit('SEND', this.text);
				} else {
					sendDM(this.text);
				}
				this.text = '';
			}
		},
		mounted() {
			this.$refs.input.addEventListener('keydown', e => {
				if (e.key.toLowerCase() === 'enter') {
					if (!(e.ctrlKey || e.metaKey || e.shiftKey)) {
						e.preventDefault();
						e.stopPropagation();
						this.onSendMessage();
					}
				}
			});
		},

		computed: {
			...mapState(['readonly'])
		}
	};
</script>

<style scoped lang="scss">
	.Input {
		display: flex;
		align-items: center;
		color: var(--clrTheme);
		padding: 1.6rem;
		box-shadow: 0px 0px 0.5rem rgba(0, 0, 0, 0.1);
		z-index: 1;
		background-color: white;

		& > * {
			&:not(:first-child) {
				margin-left: 1rem;
			}
		}

		a {
			font-size: 2rem;
		}

		textarea {
			resize: none;
			border: none;
			outline: none;
			flex: 1;
			font-size: inherit;

			&::placeholder {
				opacity: 0.5;
			}
		}
	}
</style>
